module.exports = __webpack_public_path__ + "img/photo_2025-06-03_17-38-33.89ffd10f.jpg";